"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineHeaderPropNames = exports.LineHeaderTheme = void 0;
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
var LineHeaderTheme;
(function (LineHeaderTheme) {
    LineHeaderTheme["Light"] = "light";
    LineHeaderTheme["Dark"] = "dark";
})(LineHeaderTheme = exports.LineHeaderTheme || (exports.LineHeaderTheme = {}));
/**
 * This enum is needed for better TypeScript experience
 * within the `LineHeader.stories.ts` file.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
var LineHeaderPropNames;
(function (LineHeaderPropNames) {
    LineHeaderPropNames["IsBold"] = "isBold";
    LineHeaderPropNames["ShowPointer"] = "showPointer";
    LineHeaderPropNames["Site"] = "site";
    LineHeaderPropNames["Tag"] = "tag";
    LineHeaderPropNames["Theme"] = "theme";
})(LineHeaderPropNames = exports.LineHeaderPropNames || (exports.LineHeaderPropNames = {}));
//# sourceMappingURL=LineHeader.contracts.js.map